/*------------------------------------*\
    #PRINT
\*------------------------------------*/

/*
    Toggles a print-friendly version of a page
    with custom content and styling.
    
    TRIGGER
    -------
    <a href="#" class="js-print" data-target="print">
        Print
    </a>
    
    CONTENT & STYLES
    ----------------
    <script type="text/template" id="print">
        <style type="text/css">
            Print styles
        </style>

        <!DOCTYPE html>
        <html>
            <head>
                <title></title>
            </head>
            <body class="c-print">
                Print content
            </body>
        </html>
    </script>
*/

WW.print = function($) {
    'use strict';

    let print;

    $('body').on('click', '.js-print', function(e) {
        e.preventDefault();
        let target = this.getAttribute('data-target');
        print(target);
    });
 
    print = (target) => {
        let el = $('#' + target),
            printContent,
            printObj;

        if (el.length) {
            printContent = el.html();
            printObj = window.open('', '', 'height=600,width=800' );

            printObj.document.write(printContent);
            printObj.document.close(); // necessary for IE >= 10
            printObj.focus(); // necessary for IE >= 10
            printObj.print();
            printObj.close();
        }
    };
    
    return this;
};

// place the following in main.js: .print($)